import { render, staticRenderFns } from "./RouteDataQualityReportForm.vue?vue&type=template&id=afb78bc2&scoped=true&"
import script from "./RouteDataQualityReportForm.vue?vue&type=script&lang=js&"
export * from "./RouteDataQualityReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb78bc2",
  null
  
)

export default component.exports